import * as Actions from '../actions';

const initialState = {
    courseScaffold: {
        CourseName: '',
        CourseDescription: '',
        CourseSizeLimit: 0,
        Weeks: 0,
        course_id: 0,
        Unscheduled: 0,
        Color: '#F3F1F0',
        CourseEnrollmentDescription: '',
        days: [
            { name: 'Monday', id: 2, selected: false },
            { name: 'Tuesday', id: 3, selected: false },
            { name: 'Wednesday', id: 4, selected: false },
            { name: 'Thursday', id: 5, selected: false },
            { name: 'Friday', id: 6, selected: false }
        ],
        majors: [],
        newLesson: {
            LessonName: '',
            LessonDescription: '',
            lesson_id: 0
        },
        companies: []
    },
    mappedLessons: [],
    step: 'scaffold',
    lessonDialog: false,
    lessonDialogChoice: null,
    dialogActiveLesson: null,
    new_id_counter: 0,
    availableMajors: [],
    allCompanies: [],
    companySearch: "",
}

const courseBuilderReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_COURSE_SCAFFOLD):
            {
                return {
                    ...state,
                    courseScaffold: { ...state.courseScaffold, ...action.payload }
                }
            }
        case (Actions.GET_MAJORS):
            {
                return {
                    ...state,
                    availableMajors: action.payload,
                    courseScaffold: {
                        ...state.courseScaffold,
                        majors: action.payload.map(m => {
                            return { ...m, selected: false }
                        })
                    }
                }
            }

        case (Actions.GET_COMPANY_LIST):
            {
                return {
                    ...state,
                    allCompanies: action.payload.map(c => {
                        return {
                            ...c,
                            label: c.CompanyName,
                            id: c.company_id
                        }
                    })
                }
            }

        case (Actions.BUILDER_COMPANY_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    companySearch: action.payload
                }
            }

        case (Actions.BUILDER_TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((c) => c.id === action.payload.company.id)
                    return {
                        ...state,
                        courseScaffold: {
                            ...state.courseScaffold,
                            companies: state.courseScaffold.companies.concat(newCompany)
                        }
                    }
                }
                else {
                    return {
                        ...state,
                        courseScaffold: {
                            ...state.courseScaffold,
                            companies: state.courseScaffold.companies.filter((c) => c.id !== action.payload.company.id)
                        }
                    }
                }
            }
        case (Actions.HANDLE_DAY_SELECT):
            {
                return {
                    ...state,
                    courseScaffold: {
                        ...state.courseScaffold,
                        days: state.courseScaffold.days.map(day => {
                            if (day.id === action.payload) {
                                return { ...day, selected: !day.selected }
                            }
                            return day
                        })
                    }
                }
            }
        case (Actions.HANDLE_MAJOR_SELECT):
            {
                return {
                    ...state,
                    courseScaffold: {
                        ...state.courseScaffold,
                        majors: state.courseScaffold.majors.map(major => {
                            if (major.major_id === action.payload) {
                                return { ...major, selected: !major.selected }
                            }
                            return major
                        })
                    }

                }
            }
        case (Actions.UPDATE_STEP):
            {
                let lessons = [];
                for (var i = 1; i <= state.courseScaffold.Weeks; i++) {
                    lessons.push(i);
                }

                lessons = lessons.map((weekNum, index) => (
                    state.courseScaffold.days.filter(d => d.selected === true).map(d =>
                        ({
                            WeekNum: weekNum,
                            DayOfWeek: d.id,
                            LessonName: 'Blank',
                            lesson_id: 'blank_lesson',
                            module_id: 0,
                            module_name: null
                        }))
                ));

                lessons = lessons.reduce((accu, weekObj) => {
                    return accu.concat(weekObj);
                }, []);

                switch (action.payload) {
                    case ('scaffold'):
                        {
                            return {
                                ...state,
                                step: 'blank_schedule',
                                mappedLessons: lessons

                            }
                        }
                    default:
                        {
                            return {
                                ...state
                            }
                        }
                }
            }
        case (Actions.BUILDER_LESSON_DROP):
            {
                if (state.mappedLessons.filter(lesson => lesson.DayOfWeek === action.payload.lesson.DayOfWeek && lesson.WeekNum === action.payload.lesson.WeekNum).length > 0) {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.map(lesson => {
                            if (lesson.DayOfWeek === action.payload.lesson.DayOfWeek && lesson.WeekNum === action.payload.lesson.WeekNum) {
                                return {
                                    ...lesson,
                                    WeekNum: action.payload.week,
                                    DayOfWeek: action.payload.day
                                }
                            }
                            else if (lesson.DayOfWeek === action.payload.day && lesson.WeekNum === action.payload.week) {
                                return {
                                    ...lesson,
                                    DayOfWeek: action.payload.lesson.DayOfWeek,
                                    WeekNum: action.payload.lesson.WeekNum
                                }
                            }
                            else {
                                return {
                                    ...lesson
                                }
                            }
                        })
                    }
                }
                else {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.map(lesson => {
                            if (lesson.DayOfWeek === action.payload.lesson.DayOfWeek && lesson.WeekNum === action.payload.lesson.WeekNum) {
                                return {
                                    ...lesson,
                                    WeekNum: action.payload.week,
                                    DayOfWeek: action.payload.day
                                }
                            }
                            return {
                                ...lesson
                            }
                        })
                    }
                }
            }
        case (Actions.TOGGLE_LESSON_DIALOG):
            {
                if (action.payload.unscheduled) {
                    return {
                        ...state,
                        lessonDialog: action.payload.setting,
                        dialogActiveLesson: { name: 'placeholder', new: true },
                        lessonDialogChoice: null
                    }
                }
                return {
                    ...state,
                    lessonDialog: action.payload.setting,
                    dialogActiveLesson: action.payload.info,
                    lessonDialogChoice: null
                }
            }
        case (Actions.LESSON_DIALOG_CHOICE):
            {
                let newName = ''
                let newDesc = ''
                let new_id = 'new'
                // if (action.payload === 'create' && state.dialogActiveLesson.LessonName != '') {
                //     newName = state.dialogActiveLesson.LessonName
                //     newDesc = state.dialogActiveLesson.LessonDescription
                //     new_id = state.dialogActiveLesson.lesson_id
                // }
                return {
                    ...state,
                    lessonDialogChoice: action.payload,
                    courseScaffold: {
                        ...state.courseScaffold,
                        newLesson: {
                            LessonName: newName,
                            LessonDescription: newDesc,
                            lesson_id: new_id,
                        }
                    }
                }
            }
        case (Actions.SELECT_LESSON_HUB):
            {
                const active_lesson = state.dialogActiveLesson
                if (active_lesson.new) {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.concat([{
                            WeekNum: active_lesson.WeekNum,
                            DayOfWeek: active_lesson.DayOfWeek,
                            lesson_id: action.payload.lesson_id,
                            LessonName: action.payload.LessonName,
                            LessonDescription: action.payload.LessonDescription
                        }]),
                        lessonDialog: false,
                        lessonDialogChoice: null,
                        dialogActiveLesson: null
                    }
                }
                else {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.map(lesson => {
                            if (lesson.WeekNum === active_lesson.WeekNum && lesson.DayOfWeek === active_lesson.DayOfWeek) {

                                return {
                                    ...lesson,
                                    lesson_id: action.payload.lesson_id,
                                    LessonName: action.payload.LessonName,
                                    LessonDescription: action.payload.LessonDescription
                                }
                            }
                            return { ...lesson }
                        }),
                        lessonDialog: false,
                        lessonDialogChoice: null,
                        dialogActiveLesson: null
                    }
                }
            }
        case (Actions.UPDATE_LESSON_FORM):
            {
                return {
                    ...state,
                    courseScaffold: {
                        ...state.courseScaffold,
                        newLesson: { ...state.courseScaffold.newLesson, ...action.payload }
                    }
                }
            }
        case (Actions.SUBMIT_NEW_LESSON_HEADER):
            {
                const Unscheduled = state.courseScaffold.Unscheduled;
                const active_lesson = state.dialogActiveLesson
                if (!state.dialogActiveLesson.new) {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.map(lesson => {
                            if (lesson.WeekNum === active_lesson.WeekNum && lesson.DayOfWeek === active_lesson.DayOfWeek) {
                                return {
                                    ...lesson,
                                    lesson_id: action.payload.lesson.lesson_id,
                                    LessonName: action.payload.lesson.LessonName,
                                    LessonDescription: action.payload.lesson.LessonDescription,
                                }
                            }
                            return { ...lesson }
                        }),
                        lessonDialog: false,
                        lessonDialogChoice: null,
                        dialogActiveLesson: null,
                        courseScaffold: {
                            ...state.courseScaffold,
                            newLesson: {
                                LessonName: '',
                                LessonDescription: '',
                                lesson_id: 0,
                            }
                        }
                    }
                }
                else {
                    let newLesson = {}
                    if (Unscheduled === 1) {
                        newLesson = {
                            ...action.payload.lesson,
                            WeekNum: 0,
                            DayOfWeek: 0,
                            DisplayOrder: state.mappedLessons.length + 1,
                            lesson_id: 'new'
                        }
                    }
                    else {
                        newLesson = {
                            ...action.payload.lesson,
                            WeekNum: active_lesson.WeekNum,
                            DayOfWeek: active_lesson.DayOfWeek
                        }
                    }
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.concat([newLesson]),
                        lessonDialog: false,
                        lessonDialogChoice: null,
                        dialogActiveLesson: null,
                        courseScaffold: {
                            ...state.courseScaffold,
                            newLesson: {
                                LessonName: '',
                                LessonDescription: '',
                                lesson_id: 0,

                            }
                        }
                    }
                }
            }
        case (Actions.ADD_NEW_LESSON_SETUP):
            {
                return {
                    ...state,
                    lessonDialog: true,
                    // lessonDialogChoice: 'add',
                    dialogActiveLesson: { WeekNum: action.payload.week, DayOfWeek: action.payload.day, new: true },
                    courseScaffold: {
                        ...state.courseScaffold,
                        newLesson: {
                            LessonName: '',
                            LessonDescription: '',
                            lesson_id: 'new',
                            DayOfWeek: action.payload.day,
                            WeekNum: action.payload.week
                        }
                    }
                }
            }
        case (Actions.DELETE_LESSON):
            const lesson = action.payload
            {
                return {
                    ...state,
                    mappedLessons: state.mappedLessons.filter(l => l.WeekNum != lesson.WeekNum || l.DayOfWeek != lesson.DayOfWeek)
                }
            }
        case (Actions.GET_COURSE_ID):
            {
                return {
                    ...state,
                    courseScaffold: {
                        ...state.courseScaffold,
                        course_id: action.payload
                    }
                }
            }
        case (Actions.RESET_BUILDER):
            {
                return {
                    ...initialState
                }
            }
        //// UNSCHEDULED
        case (Actions.PUSH_UNSCHEDULED_LESSON):
            {

                const displayOrder = {
                    DisplayOrder: state.mappedLessons.length + 1,
                }
                const selected = { selected: true }
                return {
                    ...state,
                    mappedLessons: state.mappedLessons.concat([{ ...action.payload.lesson, ...displayOrder }]),
                }
            }

        case (Actions.MOVE_UNSCHEDULED_LESSON):
            {
                const reorder = (list, startIndex, endIndex) => {
                    const result = Array.from(list);
                    const [removed] = result.splice(startIndex, 1);
                    result.splice(endIndex, 0, removed);

                    return result;
                };
                return {
                    ...state,
                    mappedLessons: reorder(state.mappedLessons, action.payload.dragIndex, action.payload.hoverIndex).map((lesson, index) => {
                        return {
                            ...lesson,
                            DisplayOrder: index + 1
                        }
                    })
                }
            }

        case (Actions.DELETE_UNSCHEDULED_LESSON):
            {
                return {
                    ...state,
                    mappedLessons: state.mappedLessons
                        .filter(lesson => lesson.lesson_id != action.payload.lesson_id)
                        .map((lesson, index) => {
                            return {
                                ...lesson,
                                DisplayOrder: index + 1
                            }
                        })
                }
            }

        case (Actions.CLEAR_WIZARD):
            {
                return {
                    ...initialState
                }
            }

        default:
            {
                return state;
            }
    }
}

export default courseBuilderReducer;


// WEBPACK FOOTER //
// src/main/content/course/store/reducers/builder.reducer.js